// extracted by mini-css-extract-plugin
module.exports = {"tocTitle":"toc-module--tocTitle--VhBaR","tocItems":"toc-module--tocItems--29Ikk","tocItem":"toc-module--tocItem--2tF7a","tocLink":"toc-module--tocLink--chtW4"};